import { Routes } from "@angular/router";
import { AuthGuard } from "@auth0/auth0-angular";
import { organizationGuard, ThemeGuard } from "@rr/shared-data-access-core";
export const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("@rr/feature-auth").then((m) => m.AUTH_ROUTES),
  },
  {
    path: "shell",
    loadChildren: () => import("@rr/feature-shell").then((m) => m.SHELL_ROUTES),
    canActivate: [AuthGuard, ThemeGuard, organizationGuard],
  },
  { path: "login", redirectTo: "auth/login", pathMatch: "full" },
  { path: "logout", redirectTo: "auth/logout", pathMatch: "full" },
  { path: "signup", redirectTo: "auth/signup", pathMatch: "full" },
  {
    path: "not-found",
    loadComponent: () => import("@rr/feature-exception-view-not-found").then((m) => m.NotFoundComponent),
    canActivate: [AuthGuard, organizationGuard],
  },
  {
    path: "error",
    loadComponent: () => import("@rr/feature-exception-view-error-page").then((m) => m.ErrorPageComponent),
    canActivate: [AuthGuard],
  },
  { path: "", redirectTo: "shell", pathMatch: "full" },
  { path: "**", redirectTo: "not-found", pathMatch: "full" },
];
